import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_GET_AVATARS } from 'api/notificationManager/methods';

export default class GetAvatarsRequest extends WsBaseRequest {
  constructor() {
    super(API_GET_AVATARS, {});
  }
}
